import { useQuery } from '@apollo/client';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import LearnerProfileLearningGoalQuery from 'bundles/onboarding-common/queries/LearnerProfileLearningGoal.graphql';
import type {
  LearnerProfileLearningGoalQueryQuery,
  LearnerProfileLearningGoalQueryQueryVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerProfileLearningGoal';
import { formatLearningGoalFromLearnerProfile } from 'bundles/onboarding-common/utils/savedQuestionDataUtils';

const useLearningGoalData = ({ skip }: { skip?: boolean }) => {
  const { data, loading } = useQuery<
    LearnerProfileLearningGoalQueryQuery,
    LearnerProfileLearningGoalQueryQueryVariables
  >(LearnerProfileLearningGoalQuery, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    skip,
  });

  return {
    value: formatLearningGoalFromLearnerProfile(data),
    loading,
    __typename: QUESTION_IDS.learningGoal,
  };
};

export default useLearningGoalData;
